/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './OurAwards.module.scss';

import type { ComplianceBadge, OurAwardsProps } from './OurAwards.types';

const baseClass = 'our-awards';

const COMPLIANCE_BADGES: ComplianceBadge[] = [
  { iconType: 'compliance-1', label: 'GDPR Compliant' },
  { iconType: 'compliance-2', label: 'CCPA Compliant' },
  { iconType: 'compliance-3', label: 'ISO 27001' },
  { iconType: 'compliance-4', label: 'Hosting in EU' },
];

const SPLIT_AWARD_NUMBERS = [26, 27, 28, 29];
const DEFAULT_AWARDS_COUNT = 8;

export const OurAwards = ({ title, description, className, variant = 'default' }: OurAwardsProps) => {
  const { t } = useInt();
  const isSplit = variant === 'split';

  return (
    <section className={cn(styles[`${baseClass}-wrapper`], isSplit && styles[`${baseClass}-split-wrapper`], className)}>
      <div className={styles[`${baseClass}-container`]}>
        {(title || description) && (
          <TitleBlock title={title} description={description} align={isSplit ? 'left' : 'center'} />
        )}

        {isSplit ? (
          <div className={styles[`${baseClass}-split-panels`]}>
            <div className={styles[`${baseClass}-compliance-card`]}>
              {COMPLIANCE_BADGES.map(({ iconType, label }) => (
                <div key={iconType} className={styles[`${baseClass}-compliance-item`]}>
                  <Icon type={iconType} />
                  <span className={styles[`${baseClass}-compliance-label`]}>{t(label)}</span>
                </div>
              ))}
            </div>

            <div className={styles[`${baseClass}-awards`]}>
              {SPLIT_AWARD_NUMBERS.map((number) => (
                <Icon key={number} type={`badges-${number}`} />
              ))}
            </div>
          </div>
        ) : (
          <div className={styles[`${baseClass}-awards`]}>
            {Array.from({ length: DEFAULT_AWARDS_COUNT }, (_, idx) => (
              <Icon key={idx} type={`badges-${idx + 1}`} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
